module.exports = __webpack_public_path__ + "img/question-circle-solid.493dd6dd.svg";